export default {
  home: (state) => state.home,
};
